import '@/sass/base.scss'
import { initGallerySliders } from './modules/gallery-slider'
import { initGraphs } from './modules/graph'
import { initIconifyCollection } from './modules/iconify'
import { initInitiativeInfoToggle } from './modules/initiative-info'
import { initLibrary } from './modules/library'
import { initMaps } from './modules/map'
import { initScrollToComponents } from './modules/scroll-to'
import { initNavMenu } from './modules/nav-menu'

const initPageModules = async () => {
  await initIconifyCollection()
  initScrollToComponents()
  initGallerySliders()
  initMaps()
  initGraphs()
  initLibrary()
  initNavMenu()
  initInitiativeInfoToggle()
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      void initPageModules()
    },
    {
      once: true,
    },
  )
} else {
  void initPageModules()
}
